import { render, staticRenderFns } from "./ModalDeletePost.vue?vue&type=template&id=11f77456&scoped=true&"
import script from "./ModalDeletePost.vue?vue&type=script&lang=js&"
export * from "./ModalDeletePost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f77456",
  null
  
)

export default component.exports